import * as actionTypes from '../actions/auth/actionTypes';

let _loginPath = window.sessionStorage.getItem("loginPath");
const buildName = process.env.REACT_APP_BUILD;

const initData = {
  isAuthenticated: false,
  token: undefined,
  guid:undefined,
  userDetails: undefined,
  lastLogin: undefined,
  defaultLandingRoute: '/case-list',
  unAuthorizedLandingRoute: _loginPath === '/login' || buildName === 'customer' ? '/login' : '/logout'
}

export default function authReducer(state = initData, action) {
  switch(action.type){
    case actionTypes.USER_LOGGED_IN: {
      const {isAuthenticated, token, guid, userDetails, lastLogin, defaultLandingRoute} = action;
      return {isAuthenticated, token, guid, userDetails, lastLogin, defaultLandingRoute};
    }
    case actionTypes.USER_LOGGED_OUT: {
      return {...initData};
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/reducers/authReducer.js